export const ModalConstants = {
  defaultConfirmationText: 'Yes',
  unsavedChangesConfirmation: 'Discard Changes',
  deleteConfirmationText: 'Delete'
};
